module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "myApp"
    }
  }, [_c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": _vm.dialogConfig.tip,
      "visible": _vm.dialogTopMgVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTopMgVisible = $event
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "20%"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_no')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20%",
      "width": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_yes')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "disabled": _vm.isAdmin,
      "type": "primary"
    },
    on: {
      "click": _vm.showAddApp
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addApp')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isAdmin
    },
    on: {
      "click": _vm.allUndercarriage
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulOffShelf')) + " (" + _vm._s(_vm.sNum) + ")")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "10px"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-cascader', {
    attrs: {
      "expand-trigger": "hover",
      "options": _vm.appTypes,
      "clearable": "",
      "show-all-levels": false
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.appType),
      callback: function($$v) {
        _vm.appType = $$v
      },
      expression: "appType"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_appName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "sortable": "custom",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "appCategoryName",
      "label": _vm.$t('app_type'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "distributorName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "",
      "label": _vm.$t('app_classIntrol'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isType === '0') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.classRecommend(scope.row, scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('app_yes')))]) : _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.classRecommend(scope.row, scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('app_no')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "",
      "label": _vm.$t('app_homeIntrol'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isHome === '0') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.homeRecommend(scope.row, scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('app_yes')))]) : _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.homeRecommend(scope.row, scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('app_no')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "sortable": "custom",
      "formatter": _vm.dateFormat,
      "label": _vm.$t('app_ulTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appVersion",
      "align": "center",
      "label": _vm.$t('app_newgVer'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_offShelf'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.undercarriage(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-o-down"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78c9dbcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/slot.vue
// module id = 1082
// module chunks = 0